module.exports = __webpack_public_path__ + "img/H01061-112.ad501398.jpg";